import http from "./http.service";
import Promisable from "./promisable.service";
import { modalActions } from "redux/slices/modal";
import { NavigateFunction } from "react-router-dom";
import { loaderActions } from "redux/slices/loader";
import { getAppDispatch } from "utils/dispatch.util";
import { vehicleActions } from "redux/slices/vehicle";
import { formLoaderActions } from "redux/slices/formLoader";

const url = "/vehicle";

const VehicleService = {
	addVehicle: async (data: any, navigate?: NavigateFunction) => {
		const dispatch = getAppDispatch();
		dispatch?.(formLoaderActions.setLoading(true));

		http.setJWT();

		const [success, error]: any = await Promisable.asPromise(
			http.post(`${url}`, data)
		);

		if (success) {
			const { vehicle } = success.data.data;
			dispatch?.(vehicleActions.addVehicle(vehicle));

			navigate?.(`/vehicle-details/${vehicle._id}`);
		}

		dispatch?.(formLoaderActions.setLoading(false));
		return [success, error];
	},
	updatevehicle: async (
		id: string,
		data: any,
		navigate?: NavigateFunction
	) => {
		const dispatch = getAppDispatch();
		dispatch?.(formLoaderActions.setLoading(true));

		http.setJWT();

		const [success, error]: any = await Promisable.asPromise(
			http.patch(`${url}/${id}`, data)
		);

		if (success) {
			const { vehicle } = success.data.data;
			dispatch?.(vehicleActions.updateVehicle({ id, vehicle }));
			navigate?.(`/vehicle-details/${id}`);
		}

		dispatch?.(formLoaderActions.setLoading(false));
		return [success, error];
	},
	deleteVehicle: async (id: string) => {
		const dispatch = getAppDispatch();
		dispatch?.(modalActions.setLoading(true));
		dispatch?.(formLoaderActions.setLoading(true));

		http.setJWT();

		const [success, error]: any = await Promisable.asPromise(
			http.delete(`${url}/${id}`)
		);

		if (success) {
			const { vehicle } = success.data.data;
			dispatch?.(vehicleActions.setVehicle(vehicle));
			dispatch?.(modalActions.closeModal());

		}
		dispatch?.(modalActions.setLoading(false));
		dispatch?.(formLoaderActions.setLoading(false));
		return [success, error];
	},
	getVehicle: async (id: string) => {
		const dispatch = getAppDispatch();
		dispatch?.(loaderActions.setLoading(true));

		http.setJWT();

		const [success, error]: any = await Promisable.asPromise(
			http.get(`${url}/${id}`)
		);

		if (success) {
			const { vehicle } = success.data.data;
			dispatch?.(vehicleActions.setVehicle(vehicle));
		} else dispatch?.(vehicleActions.setVehicle({ data: "Not Found" }));

		dispatch?.(loaderActions.setLoading(false));
		return [success, error];
	},
	getPetroVehicles: async () => {
		const dispatch = getAppDispatch();
		dispatch?.(loaderActions.setLoading(true));

		http.setJWT();

		const [success, error]: any = await Promisable.asPromise(
			http.get(`petro/getVehicleAll`)
		);

		if (success) {
			const { vehicles } = success.data.data;
			dispatch?.(vehicleActions.setPetroVehicles({ vehicles }));
		}

		dispatch?.(loaderActions.setLoading(false));
		return [success, error];
	},
	getAllVehicles: async (data: any = { all: "true" }) => {
		const dispatch = getAppDispatch();

		dispatch?.(vehicleActions.setLoading(true));

		http.setJWT();

		const [success, error]: any = await Promisable.asPromise(
			http.post(`${url}/get`, data)
		);

		if (success) {
			const { count, vehicles } = success.data.data;
			dispatch?.(vehicleActions.setVehicles({ count, vehicles }));
		}
		dispatch?.(vehicleActions.setLoading(false));
		return [success, error];
	},
	uploadVehicleDocs: async (id: string, data: any) => {
		const dispatch = getAppDispatch();
		dispatch?.(modalActions.setLoading(true));

		http.setJWT();
		http.setMultiPart();

		const [success, error]: any = await Promisable.asPromise(
			http.post(`${url}/upload/${id}`, data)
		);

		if (success) {
			const { vehicle } = success.data.data;
			dispatch?.(vehicleActions.setVehicle(vehicle));
			dispatch?.(modalActions.closeModal());
		}

		dispatch?.(modalActions.setLoading(false));
		return [success, error];
	},
	updateVehicleStatus: async (id: string, data: any) => {
		const dispatch = getAppDispatch();
		dispatch?.(modalActions.setLoading(true));

		http.setJWT();

		const [success, error]: any = await Promisable.asPromise(
			http.post(`${url}/status/${id}`, data)
		);

		if (success) {
			const { vehicle } = success.data.data;
			dispatch?.(vehicleActions.setVehicle(vehicle));
			dispatch?.(modalActions.closeModal());
		}

		dispatch?.(modalActions.setLoading(false));
		return [success, error];
	},
	updateVehicleDocsStatus: async (id: string, data: any) => {
		const dispatch = getAppDispatch();
		dispatch?.(modalActions.setLoading(true));

		http.setJWT();

		const [success, error]: any = await Promisable.asPromise(
			http.post(`${url}/document/status/${id}`, data)
		);

		if (success) {
			const { vehicle } = success.data.data;
			dispatch?.(vehicleActions.setVehicle(vehicle));
			dispatch?.(modalActions.closeModal());
		}

		dispatch?.(modalActions.setLoading(false));
		return [success, error];
	},
	updateRating: async () => {
		const dispatch = getAppDispatch();
		dispatch?.(modalActions.setLoading(true));

		http.setJWT();

		const [success, error]: any = await Promisable.asPromise(
			http.get(`${url}/update-rating`)
		);

		if (success) dispatch?.(modalActions.closeModal());

		dispatch?.(modalActions.setLoading(false));
		return [success, error];
	},
	checkDocumentsExpiry: async () => {
		const dispatch = getAppDispatch();
		dispatch?.(modalActions.setLoading(true));

		http.setJWT();

		const [success, error]: any = await Promisable.asPromise(
			http.get(`${url}/update-expiry`)
		);

		if (success) dispatch?.(modalActions.closeModal());

		dispatch?.(modalActions.setLoading(false));
		return [success, error];
	},
	addVehicleSubStatus: async (data: any) => {
		const dispatch = getAppDispatch();
		dispatch?.(modalActions.setLoading(true));

		http.setJWT();

		const [success, error]: any = await Promisable.asPromise(
			http.post(`${url}/logs`, data)
		);

		if (success) {
			const { log } = success.data.data;
			// dispatch?.(vehicleActions.addVehicleSubStatus(log));
			VehicleService.getVehicleSubStatuses(data.vehicle_id);
			VehicleService.getVehicle(data.vehicle_id);
			dispatch?.(modalActions.closeModal());
		}

		dispatch?.(modalActions.setLoading(false));
		return [success, error];
	},
	updateVehicleSubStatus: async (id: string, data: any) => {
		const dispatch = getAppDispatch();
		dispatch?.(modalActions.setLoading(true));

		http.setJWT();

		const [success, error]: any = await Promisable.asPromise(
			http.patch(`${url}/logs/${id}`, data)
		);

		if (success) {
			const { log } = success.data.data;
			dispatch?.(vehicleActions.updateVehicleSubStatus({ id, log }));
			if (log?.vehicle_id) VehicleService.getVehicle(log.vehicle_id);
			dispatch?.(modalActions.closeModal());
		}

		dispatch?.(modalActions.setLoading(false));
		return [success, error];
	},
	getVehicleSubStatuses: async (vehicleId: string) => {
		const dispatch = getAppDispatch();
		dispatch?.(vehicleActions.setLoading(true));

		http.setJWT();

		const [success, error]: any = await Promisable.asPromise(
			http.get(`${url}/logs/${vehicleId}`)
		);

		if (success) {
			const { logs } = success.data.data;
			dispatch?.(vehicleActions.setVehicleSubStatuses(logs));
		}

		dispatch?.(vehicleActions.setLoading(false));
		return [success, error];
	},
};

export default VehicleService;
